import { toast } from 'react-toastify';

const getToastClassName = message => {
    if (typeof message !== 'string') return 'oneline-toast';
    // Approximate 55 chars as threshold for multiline in 500px toast
    const threshold = 55;
    return message.length > threshold || message.includes('\n') ? 'multiline-toast' : 'oneline-toast';
};

const mergeOptions = (message, options) => ({
    ...options,
    className: `${options.className || ''} ${getToastClassName(message)}`,
});

export const showSuccessToast = (message, options = {}) => {
    toast.success(message, mergeOptions(message, options));
};

export const showErrorToast = (message, options = {}) => {
    toast.error(message, mergeOptions(message, options));
};

export const showInfoToast = (message, options = {}) => {
    toast.info(message, mergeOptions(message, options));
};

export const showWarningToast = (message, options = {}) => {
    toast.warn(message, mergeOptions(message, options));
};

export const dismissToast = id => {
    toast.dismiss(id);
};

export const isToastActive = id => toast.isActive(id);

export const updateToast = (id, message, options = {}) => {
    if (isToastActive(id)) {
        toast.update(id, {
            render: message,
            ...mergeOptions(message, options),
        });
        return;
    }
    const { type = 'error', ...rest } = options;
    const toastFn =
        {
            success: showSuccessToast,
            error: showErrorToast,
            info: showInfoToast,
            warning: showWarningToast,
        }[type] || showErrorToast;

    toastFn(message, { toastId: id, ...rest });
};
